import { Box, Typography } from '@mui/material'
import type { ReactNode } from 'react'

type SectionHeaderProps = {
  title: string
  subtitle?: string
  action?: ReactNode
}

function SectionHeader({ title, subtitle, action }: Readonly<SectionHeaderProps>) {
  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 1,
        backgroundColor: 'background.paper',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography
          sx={{
            fontSize: '1.125rem',
            fontWeight: 600,
            color: 'text.primary',
            lineHeight: 1.3,
          }}
        >
          {title}
        </Typography>
        {action}
      </Box>
      {subtitle && (
        <Typography
          sx={{
            fontSize: '0.8125rem',
            color: 'text.secondary',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  )
}

export default SectionHeader
